import { CustomerFeedbackSubmit, EReviewLink, FilteredCreditApplication, useGetFeedback } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface Props {
  creditApp: FilteredCreditApplication
}

const CustomerFeedbackTile = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [feedback] = useGetFeedback(creditApp.id, EFinancingProgram.B2c)
  return !feedback ? (
    <CustomerFeedbackSubmit
      creditApp={creditApp}
      reviewLink={EReviewLink.IFinance}
      financingProgram={EFinancingProgram.B2c}
    />
  ) : (
    <main className="general-message">
      <h3 style={{ marginBottom: '2rem' }}>{t('feedback.thankYouGoodReview')}</h3>
      <div className="btn-group full-width-mobile">
        <button
          type="button"
          onClick={() => navigate(`/creditapplication/${creditApp.id}`)}
          className="btn btn-blue primary-action-btn"
        >
          <i className="fa-light fa-arrow-left" />
          <span>{t('common.backToApplication')}</span>
        </button>
      </div>
    </main>
  )
}

export default memo(CustomerFeedbackTile)
